import React, { Component } from 'react';

import HomeHeader from './header/home-header'
import HomeMain from './main/home-main';
import AnimatedWrapper from '../core/animated-wrapper';
import shareService from '../../services/share';

import './home.css';

class Home extends Component {
  constructor(props) {
    super(props);

    shareService.setupPage({
      title: "Enjoy the web development world",
      fullTitle: ""
    });
  }
  
  render() {
    return (
      <section>
        <HomeHeader />
        <HomeMain />
      </section>
    );
  }
};

const AnimatedHome = AnimatedWrapper(Home);
export default AnimatedHome;